import React from 'react';
import './skeleton-loader.css';

interface SkeletonLoaderProps {
  type?: 'dashboard' | 'cards' | 'list' | 'table' | 'button';
  count?: number;
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ type = 'dashboard', count = 3 }) => {
  if (type === 'dashboard') {
    return (
      <div className="skeleton-container" role="status" aria-label="Loading dashboard" aria-busy="true">
        <span className="sr-only">Loading dashboard...</span>
        {/* Header Skeleton */}
        <div className="skeleton-header">
          <div className="skeleton-title"></div>
          <div className="skeleton-subtitle"></div>
        </div>

        {/* Stats Cards Skeleton */}
        <div className="skeleton-stats-grid">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="skeleton-stat-card">
              <div className="skeleton-stat-icon"></div>
              <div className="skeleton-stat-content">
                <div className="skeleton-stat-label"></div>
                <div className="skeleton-stat-value"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Search Bar Skeleton */}
        <div className="skeleton-search"></div>

        {/* Cards Grid Skeleton */}
        <div className="skeleton-cards-grid">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="skeleton-card">
              <div className="skeleton-card-header"></div>
              <div className="skeleton-card-body">
                <div className="skeleton-line"></div>
                <div className="skeleton-line"></div>
                <div className="skeleton-line short"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'cards') {
    return (
      <div className="skeleton-cards-grid" role="status" aria-label="Loading cards" aria-busy="true">
        <span className="sr-only">Loading cards...</span>
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className="skeleton-card">
            <div className="skeleton-card-header"></div>
            <div className="skeleton-card-body">
              <div className="skeleton-line"></div>
              <div className="skeleton-line"></div>
              <div className="skeleton-line short"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (type === 'list') {
    return (
      <div className="skeleton-list" role="status" aria-label="Loading list" aria-busy="true">
        <span className="sr-only">Loading list...</span>
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="skeleton-list-item">
            <div className="skeleton-avatar"></div>
            <div className="skeleton-list-content">
              <div className="skeleton-line"></div>
              <div className="skeleton-line short"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (type === 'table') {
    return (
      <div className="skeleton-table" role="status" aria-label="Loading table" aria-busy="true">
        <span className="sr-only">Loading table...</span>
        <div className="skeleton-table-header">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="skeleton-table-cell"></div>
          ))}
        </div>
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="skeleton-table-row">
            {[1, 2, 3, 4].map((j) => (
              <div key={j} className="skeleton-table-cell"></div>
            ))}
          </div>
        ))}
      </div>
    );
  }

  if (type === 'button') {
    return (
      <div className="skeleton-button-list" role="status" aria-label="Loading" aria-busy="true">
        <span className="sr-only">Loading...</span>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="skeleton-button"></div>
        ))}
      </div>
    );
  }

  return null;
};
